export default __webpack_public_path__ + "static/media/pricing.3a274a64.md";